import axios from "axios";

export const AxiosInstance = axios.create({
  baseURL: "/api",
  // baseURL: "https://personalbizwin.com:443/api/",
  // baseURL: "/mockData",
  // timeout: 120000,
  headers: {
    "Content-Type": "application/json"
  }
});

// AxiosInstance.interceptors.response.use((response) => {
//   const {serverState} = store.getState();
//   if (!serverState.networkConnection) {
//     store.dispatch(setNetworkConnection(true))
//   }
//   return response;
// }, (error) => {
//   // Do something with response error
//   if (error && error.toJSON && error.toJSON().message === "Network Error") {
//     store.dispatch(setNetworkConnection(false))
//   }
//   return Promise.reject(error);
// });

export const get = async (url: string) => {
  try {
    const response = await AxiosInstance.get(url);
    console.log("get "+url+" response", response);
    return response.data;
  } catch (error) {
    console.log(url + "error", error);
    return error
  }
};

export const post = async (url: string, data: any, isFormData = false) => {
  try {
    const response = isFormData
      ? await AxiosInstance.post(url, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      : await AxiosInstance.post(url, data);
    console.log("post "+url+" response", response);
    return response.data || response;
  } catch (error) {
    console.log(url + " error", error);
    return error
  }
};